var React = require('react');

function IconPiggybank (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m83.53 38a30.68 30.68 0 0 1 14.57 16.29h7.05v16.08l-6.22 3.24a30.64 30.64 0 0 1 -11.45 16.39v11.72h-10.58l-2.17-6.33a31.32 31.32 0 0 1 -5.24.46h-16.11-.78l-2 5.9h-10.6v-9a30.62 30.62 0 0 1 13.38-58.17h16.11l14.72-5.78-1.21 15.95","key":0}),React.createElement("path",{"d":"m23.56 59.64a13.26 13.26 0 0 1 16.13-9.55 10.6 10.6 0 0 1 7.64 12.91 8.49 8.49 0 0 1 -10.33 6.1 6.79 6.79 0 0 1 -4.89-8.26 5.43 5.43 0 0 1 6.61-3.91 4.35 4.35 0 0 1 3.13 5.28 3.49 3.49 0 0 1 -4.23 2.51","key":1}),React.createElement("path",{"d":"m51.54 41.6h15.46","key":2}),React.createElement("circle",{"cx":"83.69","cy":"54.16","r":".41","key":3})]);
}

IconPiggybank.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconPiggybank;

IconPiggybank.default = IconPiggybank;
